import { Outlet, ScrollRestoration } from 'react-router-dom'
import GlobalStyles from '@styles/global-styles'
import Toast from '@features/toast/toast'
import { Chat as AidbaseChat } from '@aidbase/chat'

const RootLayout: React.FC = () => {
  return (
    <>
      <ScrollRestoration />
      <GlobalStyles />
      <Toast />
      <Outlet />
      <div
        style={{
          position: 'fixed',
          bottom: 10,
          right: 10,
          zIndex: 1000,
        }}
      >
        <AidbaseChat chatbotID='rrdOfRlNdl7dqMIUnVaq_' />
      </div>
      {/* <CrispChat /> */}
    </>
  )
}

export default RootLayout
